import React from 'react';
import { UserBadgeType } from '../../../models/UserBadgeType';
import Icon, { IconName } from '../../../components/Icon';

export enum UserBadgeStyle {
  normal = 'normal',
  big = 'big'
}

// Props interface
interface UserBadgeProps {
  badge: UserBadgeType;
  style?: UserBadgeStyle;
}

const UserBadge: React.FC<UserBadgeProps> = ({
  badge,
  style = UserBadgeStyle.normal,
}) => {
  const getBadgeImage = (badge: UserBadgeType): IconName => {
    const badges = {
      [UserBadgeType.FOUNDER]: IconName.BADGE_FOUNDER,
      [UserBadgeType.GIGACHAD]: IconName.BADGE_GIGACHAD,
      [UserBadgeType.LIFETIME]: IconName.BADGE_LIFETIME,
      [UserBadgeType.SPONSOR]: IconName.BADGE_SPONSOR,
      [UserBadgeType.VETERAN]: IconName.BADGE_VETERAN,
      [UserBadgeType.NOSTR]: IconName.BADGE_NOSTR,
    };
    return badges[badge];
  };

  const getBadgeSize = (style: UserBadgeStyle): string => {
    return style === UserBadgeStyle.normal ? 'w-4 h-4' : 'w-8 h-8';
  };

  if(getBadgeImage(badge))
    return (
      <div className="relative flex items-center justify-end">
        <Icon
          name={getBadgeImage(badge)}
          alt={`${badge} badge`}
          className={getBadgeSize(style)}
        />
      </div>
    );
  else
    return null;
};

export default UserBadge;